import React,{useState, useEffect}  from "react";
import { getEstadisticaPlanes } from "../../services/Reportes.js";
import { getRecolectores } from '../../services/Recolectores';
import { getRegistroRetiros } from "../../services/RegistroRecolectores";
import { getRegistroEntregas } from "../../services/RegistroEntregas";
import { getRegistroRecepciones } from "../../services/RegistroRecepciones";

import SeleccionaFecha from '../../components/DatePicker/SeleccionaFecha';
import CardLineChart from "../../components/Cards/CardLineChart.js";
import CardPageVisits from "../../components/Cards/CardPageVisits.js";
import HeaderStats from "../../components/Headers/HeaderStats.js";

const DashboardN = () =>{
  const [selectedDate, setSelectedDate] = useState(getFirstDayOfMonth('InicioAnno')); // Fecha inicial
  const [selectedDateEnd, setSelectedDateEnd] = useState(getFirstDayOfMonth('Fin')); // Fecha inicial

  const [solicitudesT, setSolicitudesT] = useState(0);
  const [solicitudesP, setSolicitudesP] = useState(0);  // Pendiente + En Proceso
  const [equiposT, setEquiposT] = useState(0); // Total Equipos Solicitados
  const [equiposP, setEquiposP] = useState(0); // Total Equipos Pendiente
  const [criticosT, setCriticosT] = useState(0); // Total Equipos Criticos Totales
  const [criticosP, setCriticosP] = useState(0); // Total Equipos Criticos Pendientes
  const [implementaT, setImplementaT] = useState(0); // Total Equipos Implementados Totales
  const [implementaP, setImplementaP] = useState(0); // Total Equipos Implementados Pendientes
  const [labelsDataC, setLabelsDataC] = useState([]);
  const [dataDataC, setDataDataC] = useState([]);

  function getFirstDayOfMonth(Como) {
    const today = new Date();
    const firstDay = new Date(today.getFullYear(), today.getMonth(), 1);
    const firstDayYear = new Date(today.getFullYear(), 0, 1);
    if(Como === 'InicioAnno') return firstDayYear;
    if(Como === 'Inicio') return firstDay;
    if(Como === 'Fin') return today;
    if(Como === 'Nada') return null;
  };

    useEffect(()=>{
      const fetchData = async () => {

          const soliciData = await getEstadisticaPlanes(selectedDate,selectedDateEnd);

          const sumaTotalCantidad = soliciData.reduce((accumulator, { cantidad }) => {
            return accumulator + (cantidad || 0); // Asegura que no sume undefined o null
          }, 0);
          setEquiposT(sumaTotalCantidad);


          const recoData = await getRecolectores();


          setSolicitudesT(recoData ? recoData.length : 0);

        // Convertimos el objeto en un array
        const resultado = Object.values(soliciData);

        // Extraemos los arreglos
        const labels = resultado.map(item => item.nombrePlan); // ["442", "XXX", ...]
        const data = resultado.map(item => item.cantidad);  // [5, 3, ...]

          setLabelsDataC(labels);
          setDataDataC(data);

          const dataR = await getRegistroRetiros(selectedDate.toISOString(),selectedDateEnd.toISOString(),"ALL");
          if (dataR){
            const sumaRetiros = dataR.reduce((accumulator, { cantidad }) => {
              return accumulator + (cantidad || 0); // Asegura que no sume undefined o null
            }, 0);
            setImplementaT(sumaRetiros);
          }
          const dataRD = await getRegistroRecepciones(selectedDate.toISOString(),selectedDateEnd.toISOString(),"ALL");
          if (dataRD){
            const sumaRetiros = dataRD.reduce((accumulator, { cantidad }) => {
              return accumulator + (cantidad || 0); // Asegura que no sume undefined o null
            }, 0);
            setImplementaP(sumaRetiros);
          }

          

          const dataE = await getRegistroEntregas(selectedDate.toISOString(),selectedDateEnd.toISOString(),"ALL");
          if (dataE){
            const sumaEntregas = dataE.reduce((accumulator, { cantidad }) => {
              return accumulator + (cantidad || 0); // Asegura que no sume undefined o null
            }, 0);
            setCriticosT(sumaEntregas);
          }
      };
      fetchData();
    },[selectedDate,selectedDateEnd]); 


  const handleDateChange = (date) => {
    setSelectedDate(date);
  };

  const handleDateChangeEnd = (date) => {
    setSelectedDateEnd(date);
  };

  return (
    <>

    <div className="relative lg:flex-nowrap bg-blueGray-100 mt-2">
    <div className="flex flex-wrap lg:flex-nowrap mt-6">
      <div className="flex flex-wrap lg:flex-nowrap justify-center ">
        <div className="flex m-3 flex-wrap justify-center gap-1 items-center">
            <div className= "flex justify-evenly space-x-6 bg-white  w-full dark:text-gray-200 dark:bg-secondary-dark-bg  p-4 pt-9 rounded-2xl ">
                <div>
                  <SeleccionaFecha
                    selectedDate={selectedDate}
                    handleDateChange={handleDateChange}
                  />
                </div>
                <div>
                  <SeleccionaFecha
                    selectedDate={selectedDateEnd}
                    handleDateChange={handleDateChangeEnd}
                  />
                </div>
                
            </div>
        </div>
      </div>
    </div>

      <HeaderStats 
        solicitudesT={solicitudesT} 
        solicitudesP={solicitudesP}
        equiposT={equiposT}
        equiposP={equiposP} 
        criticosT={criticosT}
        criticosP={criticosP}
        implementaT={implementaT}
        implementaP={implementaP}
      />
      <div className="px-4 md:px-10 mx-auto w-full -m-24">

        <div className="flex flex-wrap">
          <div className="w-full xl:w-6/12 mb-12 xl:mb-0 px-4">
            <CardLineChart labelsData={labelsDataC} dataData={dataDataC} />
          </div>
          <div className="w-full xl:w-6/12 px-4">
          <CardPageVisits selectedDate={selectedDate.toISOString()} selectedDateEnd={selectedDateEnd.toISOString()} />
          </div>
        </div>
        <div className="flex flex-wrap mt-4">
          <div className="w-full xl:w-8/12 mb-12 xl:mb-0 px-4">
           {/* <CardPageVisits /> */} 
          </div>
          <div className="w-full xl:w-4/12 px-4">
            {/*<CardSocialTraffic />*/  }
          </div>
        </div>
      </div>
      </div>
    </>
  );
}

export default DashboardN;